// ============================================
// Queue Manager Dashboard Page
// ============================================

import { useState } from 'react';
import AppShell from '../layout/AppShell';
import { useAuth } from '../../hooks/useAuth';

const MOCK_QUEUES = [
  { id: 'q1', name: 'Premier Support Queue', cases: 24, pending: 8, priority: 'high' },
  { id: 'q2', name: 'Intune / MDM Queue', cases: 17, pending: 5, priority: 'medium' },
  { id: 'q3', name: 'Security Queue', cases: 11, pending: 3, priority: 'high' },
  { id: 'q4', name: 'General Queue', cases: 9, pending: 2, priority: 'low' },
];

export default function QueueManagerDashboardPage() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');

  const totalCases = MOCK_QUEUES.reduce((s, q) => s + q.cases, 0);
  const totalPending = MOCK_QUEUES.reduce((s, q) => s + q.pending, 0);

  const renderDashboard = () => (
    <>
      <div className="grid-stats" style={{ marginBottom: 'var(--space-6)' }}>
        <div className="glass-card stat-card animate-float-in">
          <div className="stat-card__label">📬 Total Cases</div>
          <div className="stat-card__value">{totalCases}</div>
        </div>
        <div className="glass-card stat-card animate-float-in">
          <div className="stat-card__label">⏳ Pending</div>
          <div className="stat-card__value stat-card__accent">{totalPending}</div>
        </div>
        <div className="glass-card stat-card animate-float-in">
          <div className="stat-card__label">✅ In Progress</div>
          <div className="stat-card__value">{totalCases - totalPending}</div>
        </div>
        <div className="glass-card stat-card animate-float-in">
          <div className="stat-card__label">🔢 Queues</div>
          <div className="stat-card__value">{MOCK_QUEUES.length}</div>
        </div>
      </div>

      <div className="glass-card" style={{ padding: 'var(--space-5)' }}>
        <h2 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 700, marginBottom: 'var(--space-4)' }}>📋 Active Queues</h2>
        <div className="glass-table-wrapper">
          <table className="glass-table">
            <thead><tr><th>Queue Name</th><th>Total Cases</th><th>Pending</th><th>Priority</th></tr></thead>
            <tbody>
              {MOCK_QUEUES.map((q) => (
                <tr key={q.id}>
                  <td data-label="Queue Name" style={{ fontWeight: 600 }}>{q.name}</td>
                  <td data-label="Total Cases"><span className="glass-badge glass-badge--open">{q.cases}</span></td>
                  <td data-label="Pending"><span className="glass-badge glass-badge--in_progress">{q.pending}</span></td>
                  <td data-label="Priority">
                    <span className={`glass-badge glass-badge--${q.priority === 'high' ? 'critical' : q.priority === 'medium' ? 'high' : 'medium'}`}>
                      {q.priority}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );

  const renderQueues = () => (
    <div className="grid-cards">
      {MOCK_QUEUES.map((q) => (
        <div key={q.id} className="glass-card glass-card--hover" style={{ padding: 'var(--space-5)' }}>
          <div className="flex-between" style={{ marginBottom: 'var(--space-3)' }}>
            <h3 style={{ fontWeight: 700 }}>{q.name}</h3>
            <span className={`glass-badge glass-badge--${q.priority === 'high' ? 'critical' : 'high'}`}>{q.priority}</span>
          </div>
          <div className="grid-stats" style={{ gridTemplateColumns: '1fr 1fr' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)', marginBottom: 4 }}>Total</div>
              <div style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 800 }}>{q.cases}</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)', marginBottom: 4 }}>Pending</div>
              <div style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 800, color: 'var(--accent-primary)' }}>{q.pending}</div>
            </div>
          </div>
          <div style={{ marginTop: 'var(--space-3)', height: 6, background: 'var(--bg-tertiary)', borderRadius: 'var(--radius-pill)', overflow: 'hidden' }}>
            <div style={{
              width: `${((q.cases - q.pending) / q.cases) * 100}%`,
              height: '100%',
              background: 'linear-gradient(90deg, var(--accent-secondary), var(--accent-primary))',
              borderRadius: 'var(--radius-pill)',
              transition: 'width 600ms ease',
            }} />
          </div>
          <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)', marginTop: 'var(--space-1)' }}>
            {Math.round(((q.cases - q.pending) / q.cases) * 100)}% in progress
          </div>
        </div>
      ))}
    </div>
  );

  const renderContent = () => {
    switch (activeTab) {
      case 'queues': return renderQueues();
      default: return renderDashboard();
    }
  };

  return (
    <AppShell role="queue_manager" activeTab={activeTab} onTabChange={setActiveTab}>
      {renderContent()}
    </AppShell>
  );
}
